import $ from 'jquery';

// 🛠️ asigna jQuery al objeto global ANTES de importar Owl
window.$ = window.jQuery = $;

require('owl.carousel');

export default $;